// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3EQ3Z","signatureBlock":"Footer_signatureBlock__1Qwas","signature":"Footer_signature__xJOT3"};